import React from 'react'
import { Logo } from '@/components/Logo'
import { Ico } from '@/components/icons'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

const NextVisitCard = ({ dark = false, compact = false }) => {
  const { t } = useLang()
  const a = t.acct.dashboard
  return (
    <div className="tile" style={{
      background: dark ? "var(--cocoa)" : "var(--paper)",
      color: dark ? "var(--cream)" : "var(--cocoa)",
      borderColor: dark ? "var(--cocoa)" : "var(--line)",
      padding: compact ? 16 : 22,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 14 }}>
        <div>
          <div className="kicker" style={{ color: dark ? "#E68A5C" : "var(--terracotta)", marginBottom: 8 }}>◆ {a.next_visit}</div>
          <div className="h-display" style={{ fontSize: compact ? 22 : 28 }}>{a.tune_up}</div>
          <div style={{ fontSize: 14, color: dark ? "rgba(245,239,230,0.7)" : "var(--muted)", marginTop: 4 }}>
            {a.slot}
          </div>
        </div>
        <span className="status-pill pill-upcoming"><span className="dot"/>{t.acct.manage.visits.upcoming}</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 0", borderTop: dark ? "1px solid rgba(245,239,230,0.12)" : "1px solid var(--line)", borderBottom: dark ? "1px solid rgba(245,239,230,0.12)" : "1px solid var(--line)" }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--terracotta)", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, fontSize: 13 }}>RC</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>Rico C. + 1 assistant</div>
          <div className="font-mono" style={{ fontSize: 10, color: dark ? "rgba(245,239,230,0.55)" : "var(--muted)" }}>{a.your_usual_crew}</div>
        </div>
        <div className="icon-btn" style={{ borderColor: dark ? "rgba(245,239,230,0.18)" : "var(--line-strong)", background: dark ? "rgba(245,239,230,0.06)" : "var(--paper)", color: dark ? "var(--cream)" : "var(--cocoa)" }}><Ico.msg/></div>
      </div>
      <div style={{ marginTop: 14, display: "flex", gap: 10, alignItems: "center", fontSize: 12, color: dark ? "rgba(245,239,230,0.7)" : "var(--muted)" }}>
        <span className="font-mono">{a.planned_label}</span>
        <span>{a.planned_items}</span>
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
        <button className="btn btn-primary" style={{ flex: 1, justifyContent: "center", padding: "10px 16px", fontSize: 13 }}>{a.confirm_details}</button>
        <button className="btn" style={{ padding: "10px 16px", fontSize: 13, border: dark ? "1px solid rgba(245,239,230,0.25)" : "1.5px solid var(--cocoa)", background: "transparent", color: dark ? "var(--cream)" : "var(--cocoa)" }}>{a.reschedule}</button>
      </div>
    </div>
  )
}

const DashboardA = () => {
  const { t } = useLang()
  const a = t.acct.dashboard

  const rooms = a.rooms
  const recommendations = a.recommendations
  const activity = a.activity

  return (
    <div className="app-shell">
      <Sidebar active="home"/>
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.home, "Overview"]}/>
        <div className="content">
          {/* Greeting */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: 28 }}>
            <div>
              <div className="kicker accent" style={{ marginBottom: 10 }}>◆ {a.greeting_date}</div>
              <h1 className="h-display" style={{ fontSize: 40, margin: 0 }}>
                {a.greeting_pre} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>Maria.</span>
              </h1>
              <p style={{ fontSize: 15, color: "var(--muted)", margin: "6px 0 0" }}>
                {a.attention_pre} {a.attention_post}
              </p>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button className="btn btn-ghost" style={{ padding: "10px 16px", fontSize: 13 }}><Ico.bolt/> {a.request_emergency}</button>
            </div>
          </div>

          {/* Top row — health hero + next visit */}
          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 18, marginBottom: 18 }}>
            <div className="tile dark" style={{ padding: 28, position: "relative", overflow: "hidden" }}>
              <div style={{ position: "absolute", inset: 0, opacity: 0.2 }} className="roof-pattern"/>
              <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 32, alignItems: "center", position: "relative", zIndex: 2 }}>
                <div className="ring-progress" style={{ "--p": 87, "--size": "150px", background: "conic-gradient(#E68A5C 87%, rgba(245,239,230,0.1) 0)" }}>
                  <span className="label" style={{ fontSize: 30, color: "var(--cream)" }}>87</span>
                </div>
                <div>
                  <div className="kicker" style={{ color: "#E68A5C", marginBottom: 10 }}>◆ {a.home_health} · 2455 SW 17TH</div>
                  <div className="h-display" style={{ fontSize: 36, color: "var(--cream)" }}>
                    {a.doing} <span className="font-serif" style={{ color: "#E68A5C", fontWeight: 400 }}>{a.well}</span>
                  </div>
                  <p style={{ fontSize: 14, color: "rgba(245,239,230,0.7)", margin: "8px 0 16px", lineHeight: 1.5 }}>
                    {a.summary}
                  </p>
                  <div style={{ display: "flex", gap: 18, paddingTop: 14, borderTop: "1px solid rgba(245,239,230,0.12)" }}>
                    <div>
                      <div className="font-display" style={{ fontSize: 22, fontWeight: 600, color: "#E68A5C" }}>47</div>
                      <div className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)" }}>{a.visits_since}</div>
                    </div>
                    <div>
                      <div className="font-display" style={{ fontSize: 22, fontWeight: 600, color: "#E68A5C" }}>$2,140</div>
                      <div className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)" }}>{a.saved_vs}</div>
                    </div>
                    <div>
                      <div className="font-display" style={{ fontSize: 22, fontWeight: 600, color: "#E68A5C" }}>{a.days_value}</div>
                      <div className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)" }}>{a.days_streak}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <NextVisitCard/>
          </div>

          {/* Rooms */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "20px 0 12px" }}>
            <h2 className="h-display" style={{ fontSize: 22, margin: 0 }}>{a.by_room}</h2>
            <a href="#" className="font-mono" style={{ fontSize: 11, color: "var(--terracotta)", textDecoration: "none" }}>{a.view_history}</a>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
            {rooms.map(r => (
              <div key={r.name} className="tile tile-sm">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 30, height: 30, borderRadius: 9, background: "var(--cream-2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{r.icon}</div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600 }}>{r.name}</div>
                      <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{a.last_label} {r.last.toUpperCase()}</div>
                    </div>
                  </div>
                  {r.items > 0 ? (
                    <span style={{ padding: "3px 8px", borderRadius: 999, background: r.color === "var(--terracotta)" ? "rgba(194,85,45,0.15)" : "rgba(201,154,74,0.15)", color: r.color === "var(--terracotta)" ? "var(--terracotta-deep)" : "#8A6520", fontSize: 10, fontFamily: "'Geist Mono', monospace", fontWeight: 600 }}>{r.items} {r.items > 1 ? a.items_label : a.item_label}</span>
                  ) : (
                    <span style={{ color: "var(--sage)" }}><Ico.check/></span>
                  )}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div className="health-bar" style={{ flex: 1 }}><div className="fill" style={{ width: r.health + "%", background: r.color === "var(--sage)" ? "var(--sage)" : r.color === "var(--gold)" ? "var(--gold)" : "var(--terracotta)" }}/></div>
                  <span className="font-mono" style={{ fontSize: 11, color: "var(--cocoa)", fontWeight: 600 }}>{r.health}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Recommendations + activity */}
          <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 18, marginTop: 24 }}>
            <div className="tile" style={{ padding: 22 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                <h3 className="h-display" style={{ fontSize: 18, margin: 0 }}>{a.recommended_next}</h3>
                <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>3 {a.items_label}</span>
              </div>
              {recommendations.map((it, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 1fr auto", gap: 14, alignItems: "center", padding: "14px 0", borderTop: "1px solid var(--line)" }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--terracotta)" }}/>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{it.title}</div>
                    <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>{it.reason}</div>
                    <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)", marginTop: 4 }}>{it.room.toUpperCase()} · {it.time}</div>
                  </div>
                  <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 11, fontFamily: "'Geist Mono', monospace", color: "var(--terracotta)" }}>
                    <div style={{ width: 18, height: 18, borderRadius: 5, background: i < 2 ? "var(--terracotta)" : "transparent", border: i < 2 ? "none" : "1.5px solid var(--line-strong)", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center" }}>{i < 2 && <Ico.check width="12" height="12"/>}</div>
                    {i < 2 ? a.added : a.add}
                  </label>
                </div>
              ))}
              <button className="btn btn-ghost" style={{ marginTop: 8, fontSize: 13, padding: "10px 16px", width: "100%", justifyContent: "center" }}>{a.included_in_plan}</button>
            </div>

            <div className="tile" style={{ padding: 22 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                <h3 className="h-display" style={{ fontSize: 18, margin: 0 }}>{a.recent_activity}</h3>
                <a href="#" className="font-mono" style={{ fontSize: 10, color: "var(--terracotta)", textDecoration: "none" }}>{a.view_all}</a>
              </div>
              {activity.map((act, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 14, padding: "12px 0", borderTop: "1px solid var(--line)" }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <span style={{ padding: "2px 6px", borderRadius: 4, background: act.color, color: "var(--cream)", fontFamily: "'Geist Mono', monospace", fontSize: 9, fontWeight: 600 }}>{act.tag}</span>
                  </div>
                  <div>
                    <div style={{ fontSize: 13 }}>{act.what}</div>
                    <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)", marginTop: 2 }}>{act.ts.toUpperCase()} · {act.who.toUpperCase()}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function DashboardPage() {
  return <DashboardA />
}
